import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../service/indentifyDevice";
import "../../../assets/scss/components/login/loginScreen/loginScreen.scss";
import "../../../assets/scss/components/login/loginScreen/consent.scss";
import Checkbox from "../../generic/checkbox";
import EdButton from "../../generic/edButton";
import SlideUpPopup from "../../generic/slideUpPopup";
import { IConsentRes } from "../../types/components/login/loginTypes";
import { consentKeyMap } from "../loginConstants";
import PropTypes from "prop-types";
import logo from "../../../assets/images/logo_white.jpg";
export interface ConsentScreenProps {
	consents: Array<IConsentRes>;
	mandatory: boolean;
	disable: boolean;
	onSubmit: (consents: Array<any>) => void;
	onClose?: () => void;
}

export interface ConsentScreenState {
	consents: Array<IConsentRes & { checked: boolean }>;
	isSlideUpPopupOpen?: boolean;
}

class ConsentScreen extends React.Component<ConsentScreenProps, ConsentScreenState> {
	state: ConsentScreenState = { consents: [] };
	static contextTypes = { scrollToDoc: PropTypes.string };
	static propTypes = { y: PropTypes.number };

	componentDidMount = () => {
		this.setState({ consents: this.props.consents.map((consent) => ({ ...consent, checked: true })) });
	};

	scroll = (id: string) => {
		if (DeviceContext().isMobile) {
			this.setState({ isSlideUpPopupOpen: false });
		}

		(document.getElementsByClassName("cnsnts")[0] as HTMLDivElement).scrollTo({
			top: (document.getElementById(id)?.offsetTop || 0) - (document.getElementsByClassName("cnsnts")[0] as HTMLDivElement).offsetTop,
			left: 0,
			behavior: "smooth"
		});
	};

	onCheckboxToggle = (index: number) => {
		if (index >= 0) {
			const consents = [...this.state.consents];
			const consent = { ...consents[index] };

			consent.checked = !this.state.consents[index].checked;
			consents[index] = consent;

			this.setState({ consents });
		} else {
			const isAllSelected = this.state.consents.every((consent) => consent.checked);
			// if all are not selected then select all, otherwise unselect all
			this.setState({ consents: this.state.consents.map((consent) => ({ ...consent, checked: !isAllSelected })) });
		}
	};

	render() {
		const submitBtn = (
			<EdButton
				value="Accept and Proceed"
				btnTyp="primary"
				className="btn mg-t10"
				disabled={this.props.disable || (this.props.mandatory && this.state.consents.some((consent) => !consent.checked))}
				onClick={() =>
					this.props.onSubmit(this.state.consents.map((consent) => ({ cnsntNm: consent.key, sts: consent.checked ? "Y" : "RL" })))
				}
			/>
		);

		return (
			<>
				<LoginPopup
					leftHeaderContent={DeviceContext().isMobile ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
					centerHeaderContent={DeviceContext().isMobile ? undefined : <img src={logo} alt="nuvama" className="nuvama_logo"/>}
					onClose={this.props.onClose}
					className="change_pw_scrn"
				>
					<section className="cnsnt_scrn">
						<h1 className="title">Terms and Conditions</h1>
						<div className="cnsnts">
							{this.state.consents.map((consent) => (
								<React.Fragment key={consent.key}>
									<h2 className="heading mg-b10" id={consent.key}>
										{consentKeyMap[consent.key]}
									</h2>
									<p className="cnsnt mg-b20" dangerouslySetInnerHTML={{ __html: consent.val }} />
								</React.Fragment>
							))}
						</div>
						{!DeviceContext().isMobile && (
							<div className={"chkbx_cont mg-t25 mg-b25" + (this.state.consents.length === 1 ? " single" : "")}>
								{this.state.consents.map((consent, index) => (
									<Checkbox key={consent.key} checked={consent.checked} name="consent" onChange={() => this.onCheckboxToggle(index)}>
										I understand and accept{" "}
										<button className="link" onClick={() => this.scroll(consent.key)}>
											{consentKeyMap[consent.key]}
										</button>
									</Checkbox>
								))}
							</div>
						)}
						<div className="btn_cont">
							{DeviceContext().isMobile ? (
								<EdButton value="Accept" btnTyp="primary" className="btn" onClick={() => this.setState({ isSlideUpPopupOpen: true })} />
							) : (
								submitBtn
							)}
						</div>
					</section>
				</LoginPopup>
				{DeviceContext().isMobile && this.state.isSlideUpPopupOpen && (
					<SlideUpPopup closePopup={() => this.setState({ isSlideUpPopupOpen: false })}>
						<div className="cnsnt_popup">
							<h2 className="title">Accept Terms and Conditions</h2>
							<button className="cls" onClick={() => this.setState({ isSlideUpPopupOpen: false })}>
								<i className="edel-icon-close"></i>
							</button>

							<ul className="mg-t35 chkbx_cont">
								{this.state.consents.map((consent, index) => (
									<li key={consent.key} className="mg-b20">
										<Checkbox checked={consent.checked} name="consent" onChange={() => this.onCheckboxToggle(index)}>
											I understand and accept{" "}
											<button className="link" onClick={() => this.scroll(consent.key)}>
												{consentKeyMap[consent.key]}
											</button>
										</Checkbox>
									</li>
								))}

								<li className="mg-b20">
									<Checkbox
										checked={this.state.consents.every((consent) => consent.checked)}
										name="consent"
										onChange={() => this.onCheckboxToggle(-1)}
									>
										Accept All
									</Checkbox>
								</li>
							</ul>

							{/* Button should be disabled if consent is mandatory and any consent is not selected */}
							{submitBtn}
						</div>
					</SlideUpPopup>
				)}
			</>
		);
	}
}

export default ConsentScreen;
